


































import axios from "axios";
import Multiselect from "vue-multiselect";
import { defineComponent, ref, watch } from "@vue/composition-api";

import store from "@/store/root";
import { auth as manager } from "@/auth";

const { debounce } = require("lodash");

interface CodeResult {
  codeid: string;
  year: string;
  codeset: string;
  codename: string;
  comparable: "True" | "False";
}

interface Props {
  selected: CodeResult[];
  comparable: boolean | null;
  systems: string[];
}

export default defineComponent<Props>({
  name: "CodeSearch",
  components: {
    Multiselect
  },
  props: {
    selected: { type: Array },
    comparable: { type: Boolean, default: null },
    systems: { type: Array, default: () => [] }
  },
  setup(props: Props, context) {
    const available = ref<CodeResult[]>([]);

    const isLoading = ref(false);

    const calculateCodeSystem = (raw: string) => {
      if (raw === "icd10cm") return "ICD-10-CM";
      if (raw === "icd9cm") return "ICD-9-CM";
      if (raw === "hcpcs") return "HCPCS";
      if (raw === "drg") return "DRG";
      return "";
    };

    const search = debounce(async (term: string) => {
      if (term.length < 3) {
        isLoading.value = false;
        return;
      }

      return await axios
        .get<CodeResult[]>(
          `${store.state.settings.current.endpoints.lien.replace(
            /^(.*)\/?$/,
            "$1"
          )}/codes`,
          {
            params: {
              term: term
                .trim()
                .toUpperCase()
                .replaceAll(".", "")
            },
            headers: manager.enabled ? await manager.headers() : {}
          }
        )
        .then(response => response.data)
        .then(data => {
          available.value = data
            .filter(
              code =>
                props.systems.length === 0 ||
                props.systems.includes(code.codeset)
            )
            .filter(code =>
              props.comparable === true
                ? code.comparable === "True"
                : props.comparable === false
                ? code.comparable === "False"
                : true
            )
            .map(code => ({
              code: `${code.codeid}:${code.codeset}:${code.year}`,
              found: true,
              ...code
            }));
        })
        .finally(() => {
          isLoading.value = false;
        });
    }, 1000);

    return {
      available,
      isLoading,
      calculateCodeSystem,
      search: async (term: string) => {
        isLoading.value = true;
        await search(term);
      }
    };
  }
});
